// extracted by mini-css-extract-plugin
export default {"productGallery":"vL-z","inQuickShop":"wL-z"};